import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

/**
 * Guard que restringe rutas a usuarios con privilegios de management.
 *
 * Criterio: tener el claim `changelog:view` que el backend emite SOLO a users
 * con Rol_Id 1 (Admin) o 26 (Administración). Es la misma regla que define
 * "atendedor de clientes" en el chat — coherente con el concepto de "user
 * con privilegios elevados".
 *
 * Si no califica → redirect al home + toast informativo. Si no está logueado,
 * el `AuthGuardService` general ya lo hubiera mandado a /auth/sign-in antes.
 *
 * NOTA: el nombre "AdminGuard" se mantiene por simplicidad, pero internamente
 * cubre Admin + Administración (no solo Rol_Id=1).
 */
@Injectable({ providedIn: 'root' })
export class AdminGuardService implements CanActivate {
  private auth = inject(AuthService);
  private router = inject(Router);
  private translate = inject(TranslateService);

  canActivate(): boolean {
    if (this.auth.hasPermission('changelog:view')) return true;

    notify({
      message: this.translate.instant('common.accesoDenegadoAdmin')
        || 'Esta sección es solo para administradores.',
      type: 'warning',
      displayTime: 4000,
      position: { my: 'top right', at: 'top right', offset: '-20 70' },
    });
    void this.router.navigate(['/']);
    return false;
  }
}
